import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Login } from "./pages/login";
import { Resetpassword, Resetpasswordsuccess } from "./pages/resetpassword";
import { ChooseRegister } from "./pages/chooseregister";
import { Register } from "./pages/register";
import { RegisterSendMail } from "./pages/registersendmail";
import { RegisterSuccess } from "./pages/registersuccess";
import { ForgetPassword } from "./pages/forgetpass/index";
import { ForgetpassSendMail } from "./pages/forgetpass/sendmail";
import { ForgetpassChange } from "./pages/forgetpass/change";
import { ForgetpassSuccess } from "./pages/forgetpass/success";
import { Layout } from "./layouts/layout";
import { EmpPermission, EmpManagePermission, Permission } from "pages/employee/permission";
import { Emp, EmpCreate } from "pages/employee/emp";
import { Distributor, DistributorGroup } from "pages/distributor/distributor";
import { DistributorCreate } from "pages/distributor/distributorCreate";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import GlobalLoader from "layouts/GlobalLoader";
import { Routes, Route } from "react-router-dom";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import GlobalModal from "layouts/GlobalModal";
import ProtectedRoutes from "router/protected.routes";
import PublicRoutes from "router/public.routes";
import { VER, domain } from "constants/server/api";
import NotFoundPage from "pages/NotFoundPage";
import { Dashboard } from "pages/index";
import { PRList } from "pages/purchase/requisitionDatalist";
import { PRCreate } from "pages/purchase/requisition";
import { POList } from "pages/purchase/orderDatalist";
import { POCreate } from "pages/purchase/Order";
import { InfoInex } from "pages/info/index";
import { InfoCreate } from "pages/info/create";
import { PRPrint } from "layouts/PrintPR";
import { POPrint } from "layouts/PrintPO";
import { useReactToPrint } from "react-to-print";
import { GRList } from "pages/goodsreceipt/GoodsReceiptDatalist";
import { GoodsReceipt } from "pages/goodsreceipt/GoodsReceipt";
import { CreditorList } from "pages/financial/creditors/datalist";
import { CheckGoodsReceipt } from "pages/financial/creditors/GoodsReceipt";
import { env } from "env";
import { GRPrint } from "layouts/PrintGR";
import { testData } from "mocks/printGrData";
import { ReportBuySupplier } from "pages/report/buy/supplier";
import { ReportBuyOrder } from "pages/report/buy/order";
import { ReportBuyPoItem } from "pages/report/buy/poItem";
import { ReportBuyGrItem } from "pages/report/buy/grItem";
import { ExpenseList } from "pages/financial/expense/datalist";
import { ExpenseCreate } from "pages/financial/expense/expense";
import { ReportGrItemExpense } from "pages/report/buy/grItemWithExpense";
import { Product } from "pages/product/product";
import { ProductNormal } from "pages/product/productNormal";
import { ProductOption } from "pages/product/productOption";
import { Present } from "pages/product/present";
import { PresentView } from "pages/product/presentview";
import { Billing, BillingCreate } from "pages/manage/billing";
import { Invoice, InvoiceManage } from "pages/manage/invoice";
import { Catalog } from "pages/catalog";
import { Cart } from "pages/cart";
import { Reserver } from "pages/reserver";
import { ReserverTracking } from "pages/reserverTracking";
function App() {
    var _useState = _sliced_to_array(useState(1), 2), selectbranchID = _useState[0], setSelectBranchID = _useState[1];
    var isLoading = useGlobalLoaderContext().isLoading;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    useEffect(function() {
        console.log("env", env.REACT_APP_ENV);
        console.log("domain-api", domain);
        console.log("version", VER);
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isLoading && /*#__PURE__*/ _jsx(GlobalLoader, {}),
            /*#__PURE__*/ _jsx(GlobalModal, {
                show: modalObj.visible,
                title: modalObj.title,
                subTitle: modalObj.subTitle,
                btnText: modalObj.btnText,
                onHide: function() {
                    return setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                        visible: false
                    }));
                }
            }),
            /*#__PURE__*/ _jsxs(Routes, {
                children: [
                    /*#__PURE__*/ _jsx(Route, {
                        path: "/reset/password",
                        element: /*#__PURE__*/ _jsx(Resetpassword, {})
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        path: "/reset/password/success",
                        element: /*#__PURE__*/ _jsx(Resetpasswordsuccess, {})
                    }),
                    /*#__PURE__*/ _jsxs(Route, {
                        element: /*#__PURE__*/ _jsx(PublicRoutes, {}),
                        children: [
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/catalog/:typeShop",
                                element: /*#__PURE__*/ _jsx(Catalog, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/cart/:guestId",
                                element: /*#__PURE__*/ _jsx(Cart, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/reserver/:reserverCode",
                                element: /*#__PURE__*/ _jsx(Reserver, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/reserver/:reserverCode/tracking",
                                element: /*#__PURE__*/ _jsx(ReserverTracking, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/reserver-tracking/:reserverCode",
                                element: /*#__PURE__*/ _jsx(ReserverTracking, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/login",
                                element: /*#__PURE__*/ _jsx(Login, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/chooseregister",
                                element: /*#__PURE__*/ _jsx(ChooseRegister, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/register",
                                element: /*#__PURE__*/ _jsx(Register, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/register/sendmail",
                                element: /*#__PURE__*/ _jsx(RegisterSendMail, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/register/success",
                                element: /*#__PURE__*/ _jsx(RegisterSuccess, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/forgetpass",
                                element: /*#__PURE__*/ _jsx(ForgetPassword, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/forgetpass/sendmail",
                                element: /*#__PURE__*/ _jsx(ForgetpassSendMail, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/forgetpass/change",
                                element: /*#__PURE__*/ _jsx(ForgetpassChange, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "/forgetpass/success",
                                element: /*#__PURE__*/ _jsx(ForgetpassSuccess, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        element: /*#__PURE__*/ _jsx(ProtectedRoutes, {}),
                        children: /*#__PURE__*/ _jsxs(Route, {
                            path: "/",
                            element: /*#__PURE__*/ _jsx(Layout, {
                                setSelectBranchID: setSelectBranchID,
                                selectbranchID: selectbranchID
                            }),
                            children: [
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/dashboard",
                                    element: /*#__PURE__*/ _jsx(Dashboard, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emps",
                                    element: /*#__PURE__*/ _jsx(Emp, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emps/create",
                                    element: /*#__PURE__*/ _jsx(EmpCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emps/edit/:empID",
                                    element: /*#__PURE__*/ _jsx(EmpCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emp/permission",
                                    element: /*#__PURE__*/ _jsx(EmpPermission, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emp/permission/create",
                                    element: /*#__PURE__*/ _jsx(EmpManagePermission, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emp/permission/edit/:empID",
                                    element: /*#__PURE__*/ _jsx(EmpManagePermission, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/permission",
                                    element: /*#__PURE__*/ _jsx(Permission, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/info",
                                    element: /*#__PURE__*/ _jsx(InfoInex, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/info/create",
                                    element: /*#__PURE__*/ _jsx(InfoCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/distributor",
                                    element: /*#__PURE__*/ _jsx(Distributor, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/distributorgroup",
                                    element: /*#__PURE__*/ _jsx(DistributorGroup, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/distributor/create",
                                    element: /*#__PURE__*/ _jsx(DistributorCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/distributor/edit/:supID",
                                    element: /*#__PURE__*/ _jsx(DistributorCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/requisition",
                                    element: /*#__PURE__*/ _jsx(PRList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/requisition/create",
                                    element: /*#__PURE__*/ _jsx(PRCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/requisition/edit/:prID",
                                    element: /*#__PURE__*/ _jsx(PRCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/orders",
                                    element: /*#__PURE__*/ _jsx(POList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/order/create",
                                    element: /*#__PURE__*/ _jsx(POCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/order/edit/:poID",
                                    element: /*#__PURE__*/ _jsx(POCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/goods-receipt",
                                    element: /*#__PURE__*/ _jsx(GRList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/goods-receipt/:action/:dataID",
                                    element: /*#__PURE__*/ _jsx(GoodsReceipt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/creditor",
                                    element: /*#__PURE__*/ _jsx(CreditorList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/creditor/goods-receipt/:dataID",
                                    element: /*#__PURE__*/ _jsx(CheckGoodsReceipt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/expenses",
                                    element: /*#__PURE__*/ _jsx(ExpenseList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/expense/:action",
                                    element: /*#__PURE__*/ _jsx(ExpenseCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/expense/:action/:dataID",
                                    element: /*#__PURE__*/ _jsx(ExpenseCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/buy/supplier",
                                    element: /*#__PURE__*/ _jsx(ReportBuySupplier, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/buy/order",
                                    element: /*#__PURE__*/ _jsx(ReportBuyOrder, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/buy/po-item",
                                    element: /*#__PURE__*/ _jsx(ReportBuyPoItem, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/buy/gr-item",
                                    element: /*#__PURE__*/ _jsx(ReportBuyGrItem, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/financial/gr-item-expense",
                                    element: /*#__PURE__*/ _jsx(ReportGrItemExpense, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/product",
                                    element: /*#__PURE__*/ _jsx(Product, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/product/productnormal/create",
                                    element: /*#__PURE__*/ _jsx(ProductNormal, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/product/productnormal/edit/:dataID",
                                    element: /*#__PURE__*/ _jsx(ProductNormal, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/product/productnormal/edit/:dataID/:view",
                                    element: /*#__PURE__*/ _jsx(ProductNormal, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/product/productoption/create",
                                    element: /*#__PURE__*/ _jsx(ProductOption, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/product/present/create",
                                    element: /*#__PURE__*/ _jsx(Present, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/product/present/edit/:dataID",
                                    element: /*#__PURE__*/ _jsx(Present, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/product/present/:dataID",
                                    element: /*#__PURE__*/ _jsx(PresentView, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/billing",
                                    element: /*#__PURE__*/ _jsx(Billing, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/billing/edit/:dataID",
                                    element: /*#__PURE__*/ _jsx(BillingCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/invoice",
                                    element: /*#__PURE__*/ _jsx(Invoice, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/invoice/edit/:dataID",
                                    element: /*#__PURE__*/ _jsx(InvoiceManage, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        path: "*",
                        element: /*#__PURE__*/ _jsx(NotFoundPage, {})
                    })
                ]
            })
        ]
    });
}
function Home() {
    return /*#__PURE__*/ _jsx("div", {});
}
function Layoutadmin() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "page",
        children: [
            /*#__PURE__*/ _jsx(Layout, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "main-content app-content"
            })
        ]
    });
}
export default App;
